import ApplicationController from 'javascript/controllers/application_controller';

export default class extends ApplicationController {
  onClick() {
    window.document
      .querySelector('.popup')
      .setAttribute('data-should-hide', 'true');
  }
}
